export const Types = {
    INDIVIDUAL: "individual",
    VEHICLE: "vehicle",
    ENCOUNTER: "encounter",
    OCCURRENCE: "occurrence",
    SOS: "sos",
    BO: "bo",
    PASSAGE: "passage",
    COINCIDENT_PASSAGES: "coincidentPassages",
    COMPANY: "company",
    SOCIAL_MEDIA: "social_media",
    NEWS: "news",
    IMAGE: "image",
    ANNOTATION: "annotation",
}